import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component className="pos--fix --spacing4 --size-S --transparent" type={"SiteHeader"} item={{"color":"rgba(255,255,255,1)","colorHover":"rgba(237,105,35,1)","className":"ff--2 fs--16"}} fixed={true} title={{"color":"rgba(255,255,255,1)","content":"Půjčovna dodávek Ostrava","className":"fs--26"}} button={{"content":"dodávky","page":"/","className":"btn-box btn-box--pbtn3 btn-box--shape5 fs--16"}} layout={"3"} social={{"twitter":"","facebook":"","instagram":""}} transparent={true} backgroundColor={"rgba(0,0,0,1)"} />
)
}